// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.properties-head {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.properties-head h3 {
  margin: 5px;
}
.properties-head h1 {
  color: grey;
  font-size: 18px;
}

mat-divider {
  margin-top: 9.5px;
  margin-bottom: 7px;
}

.input-errors {
  color: red;
}

::ng-deep .head-properties .mat-form-field {
  font-size: 20px;
}
::ng-deep .head-properties .mat-form-field mat-error div {
  width: auto;
  border-style: solid;
  border-radius: 5px;
  background: #b71c1c;
  color: white;
  margin-top: 4px;
}

input.mat-input-element {
  color: gray;
  font-weight: normal;
}

fieldset {
  width: 99.3%;
}
fieldset .mat-radio-label {
  color: grey;
}
fieldset span p {
  margin: 5px 10px 4px 10px;
}
fieldset legend {
  font-size: 11px;
}

.choice-control-properties,
.radio-control-properties,
.textbox-control-properties,
.number-control-properties,
.date-control-properties,
.email-control-properties,
.website-control-properties,
.phone-control-properties,
.currency-control-properties,
.signature-control-properties,
.name-control-properties,
.address-control-properties,
.upload-control-properties {
  display: flex;
  flex-direction: column;
}

.type-radio {
  display: flex;
  font-size: 14px;
  flex-direction: column;
}
.type-radio .mat-radio-button {
  margin: 0px 0px 5px 5px;
}
.type-radio .mat-radio-button:last-child {
  margin-bottom: 0px !important;
}

.field-set-type, .field-set-type-options {
  border: 1px solid rgb(211, 211, 211);
  font-size: 14px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}
.field-set-type legend, .field-set-type-options legend {
  font-weight: bold;
  color: gray;
}
.field-set-type span, .field-set-type-options span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  word-break: break-all;
}

.eform-btn-actions {
  border-radius: 5px;
}

.eform-btn-actions-first {
  border-radius: 5px 0px 0px 5px;
}

.eform-btn-actions-mid {
  border-radius: 0px 0px 0px 0px;
}

.eform-btn-actions-last {
  border-radius: 0px 5px 5px 0px;
}

.field-option {
  width: 255px;
}

.field-set {
  border-color: red;
}

.margin-left-5 {
  margin-left: 5px;
}

.margin-left-10 {
  margin-left: 10px;
}

.margin-left-15 {
  margin-left: 15px;
}

.margin-left-25 {
  margin-left: 25px;
}

.field-set-type-options {
  padding: 4px;
}

.field-set-type-buttons {
  border: 1px solid rgb(211, 211, 211);
  font-size: 14px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.field-set-type-buttons legend {
  font-weight: bold;
  color: gray;
}
.field-set-type-buttons span {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.choice-options {
  height: 130px;
  overflow-x: hidden;
  word-wrap: break-word !important;
}

.type-choice {
  display: flex;
  font-size: 14px;
  flex-direction: column;
}
.type-choice .mat-radio-button {
  margin: 0px 0px 5px 5px;
}
.type-choice .mat-radio-button:last-child {
  margin-bottom: 0px !important;
}

.field-choice-layout {
  display: flex;
  justify-content: space-around;
}
.field-choice-layout button {
  width: 100% !important;
}
.field-choice-layout button mat-icon {
  transform: scale(1.2);
}

.active {
  background: lightblue;
}

.choice-header-options {
  display: flex;
  justify-content: space-around;
  font-size: 12px;
  font-weight: bolder;
}

.lookup {
  justify-content: left !important;
}

.choices-body-options {
  display: flex;
  justify-content: flex-start;
  margin: 0px !important;
  padding: 1.5px;
}

.options-label {
  width: 170px !important;
}

.options-value {
  width: 70px !important;
  margin-left: 4px;
}

.options-tableName {
  width: 160px !important;
}

.options-columnName {
  margin-left: 4px;
  width: 100px !important;
}

.btn-options {
  margin-left: 60px;
  margin-bottom: 10px;
}

.options-margin-left-20 {
  margin-left: 20px;
}

.icon-reorder-option {
  font-size: 15px;
  height: 0;
  width: 0;
  z-index: 100;
  color: grey;
  cursor: move;
}

.cdk-drag-preview {
  opacity: 0;
}

.choice-custom-placeholder {
  background: #ccc;
  width: 260px;
  height: 28px;
  border: dotted 2px #999;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

::ng-deep .tooltip-red {
  background: #b71c1c;
}

.actions-option {
  align-self: center;
  margin-left: -3px;
}
.actions-option mat-icon {
  color: grey;
  font-size: 15px;
  height: 0;
  width: 10px !important;
  margin-left: 5px;
  cursor: pointer;
}

.errors-choice {
  border-color: red;
}

.alert-icon {
  margin-right: -13px;
  font-size: 20px;
  color: red;
}

::ng-deep .choice-control-properties .choices-body-options .mat-form-field-label {
  font-size: 11px !important;
  font-weight: bold;
}

::ng-deep .choice-control-properties .choices-body-options .mat-form-field-wrapper {
  margin: 0px !important;
}

::ng-deep .choice-control-properties .choices-body-options .mat-form-field-appearance-outline .mat-form-field-infix {
  font-size: 11px !important;
  font-weight: bold;
  margin: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-control/properties/_properties-theme.scss","webpack://./src/app/e-form/form-control/properties/choice-properties/choice-properties.component.scss"],"names":[],"mappings":"AAUA;EACG,aAAA;EACA,uBAAA;EACA,eAAA;ACTH;ADWG;EACG,WAAA;ACTN;ADYG;EACG,WAAA;EACA,eAAA;ACVN;;ADcA;EACG,iBAAA;EACA,kBAAA;ACXH;;ADcA;EACG,UAAA;ACXH;;ADcA;EACG,eAAA;ACXH;ADcM;EACG,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;ACZT;;ADiBA;EACG,WAAA;EACA,mBAAA;ACdH;;ADiBA;EACG,YAAA;ACdH;ADeG;EACG,WAAA;ACbN;ADiBM;EACG,yBAAA;ACfT;ADmBG;EACG,eAAA;ACjBN;;ADqBA;;;;;;;;;;;;;EAcG,aAAA;EACA,sBAAA;ACnBH;;ADsBA;EACG,aAAA;EACA,eAAA;EACA,sBAAA;ACnBH;ADqBG;EACG,uBAAA;ACnBN;ADqBG;EACG,6BAAA;ACnBN;;ADuBA;EACG,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;ACpBH;ADsBG;EACG,iBAAA;EACA,WAAA;ACpBN;ADuBG;EACG,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;ACrBN;;ADyBA;EACG,kBAAA;ACtBH;;ADyBA;EACG,8BAAA;ACtBH;;ADyBA;EACG,8BAAA;ACtBH;;ADyBA;EACG,8BAAA;ACtBH;;ADyBA;EACG,YAAA;ACtBH;;ADyBA;EACE,iBAAA;ACtBF;;ADyBA;EACG,gBAAA;ACtBH;;ADyBA;EACG,iBAAA;ACtBH;;ADyBA;EACG,iBAAA;ACtBH;;ADyBA;EACG,iBAAA;ACtBH;;AAxIA;EACG,YAAA;AA2IH;;AAxIA;EACG,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA2IH;AAzIG;EACG,iBAAA;EACA,WAAA;AA2IN;AAxIG;EACG,aAAA;EACA,mBAAA;EACA,8BAAA;AA0IN;;AAtIA;EACG,aAAA;EACA,kBAAA;EACA,gCAAA;AAyIH;;AAtIA;EACG,aAAA;EACA,eAAA;EACA,sBAAA;AAyIH;AAvIG;EACG,uBAAA;AAyIN;AAvIG;EACG,6BAAA;AAyIN;;AArIA;EACG,aAAA;EACA,6BAAA;AAwIH;AAtIG;EACG,sBAAA;AAwIN;AAtIM;EACG,qBAAA;AAwIT;;AAnIA;EACG,qBAAA;AAsIH;;AAnIA;EACG,aAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;AAsIH;;AAnIA;EACG,gCAAA;AAsIH;;AAnIA;EACG,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;AAsIH;;AAnIA;EACG,uBAAA;AAsIH;;AAnIA;EACG,sBAAA;EACA,gBAAA;AAsIH;;AAnIA;EACG,uBAAA;AAsIH;;AAnIA;EACG,gBAAA;EACA,uBAAA;AAsIH;;AAnIA;EACG,iBAAA;EACA,mBAAA;AAsIH;;AAnIA;EACG,iBAAA;AAsIH;;AAnIA;EACG,eAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAsIH;;AAnIA;EACG,UAAA;AAsIH;;AAnIA;EACG,gBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,sDAAA;AAsIH;;AAnIA;EACG,mBAAA;AAsIH;;AAnIA;EACG,kBAAA;EACA,iBAAA;AAsIH;AArIG;EACG,WAAA;EACA,eAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAuIN;;AAnIA;EACG,iBAAA;AAsIH;;AAnIA;EACG,mBAAA;EACC,eAAA;EACA,UAAA;AAsIJ;;AAnIA;EACG,0BAAA;EACA,iBAAA;AAsIH;;AAnIA;EACG,sBAAA;AAsIH;;AAnIA;EACG,0BAAA;EACA,iBAAA;EACA,sBAAA;AAsIH","sourcesContent":["@import \"@angular/material\";\n\n@mixin eform-properties-theme($theme) {\n   $primary: map-get($theme, primary);\n   $accent: map-get($theme, accent);\n   $warn: map-get($theme, warn);\n   $background: map-get($theme, background);\n   $foreground: map-get($theme, foreground);\n}\n\n.properties-head {\n   display: flex;\n   justify-content: center;\n   flex-wrap: wrap;\n\n   h3 {\n      margin: 5px;\n   }\n\n   h1 {\n      color: grey;\n      font-size: 18px;\n   }\n}\n\nmat-divider {\n   margin-top: 9.5px;\n   margin-bottom: 7px;\n}\n\n.input-errors {\n   color: red;\n}\n\n::ng-deep .head-properties .mat-form-field {\n   font-size: 20px;\n\n   mat-error {\n      div {\n         width: auto;\n         border-style: solid;\n         border-radius: 5px;\n         background: #b71c1c;\n         color: white;\n         margin-top: 4px;\n      }\n   }\n}\n\ninput.mat-input-element {\n   color: gray;\n   font-weight: normal;\n}\n\nfieldset {\n   width: 99.3%;\n   .mat-radio-label {\n      color: grey;\n   }\n\n   span {\n      p {\n         margin: 5px 10px 4px 10px;\n      }\n   }\n\n   legend {\n      font-size: 11px;\n   }\n}\n\n.choice-control-properties,\n.radio-control-properties,\n.textbox-control-properties,\n.number-control-properties,\n.date-control-properties,\n.email-control-properties,\n.website-control-properties,\n.phone-control-properties,\n.currency-control-properties,\n.signature-control-properties,\n.name-control-properties,\n.address-control-properties,\n.upload-control-properties\n {\n   display: flex;\n   flex-direction: column;\n}\n\n.type-radio {\n   display: flex;\n   font-size: 14px;\n   flex-direction: column;\n\n   .mat-radio-button {\n      margin: 0px 0px 5px 5px;\n   }\n   .mat-radio-button:last-child {\n      margin-bottom: 0px !important;\n   }\n}\n\n.field-set-type, .field-set-type-options {\n   border: 1px solid rgb(211, 211, 211);\n   font-size: 14px;\n   border-radius: 5px;\n   display: flex;\n   flex-direction: column;\n   margin-bottom: 5px;\n\n   legend {\n      font-weight: bold;\n      color: gray;\n   }\n\n   span {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      word-break: break-all;\n   }\n}\n\n.eform-btn-actions {\n   border-radius: 5px;\n}\n\n.eform-btn-actions-first {\n   border-radius: 5px 0px 0px 5px;\n}\n\n.eform-btn-actions-mid {\n   border-radius: 0px 0px 0px 0px;\n}\n\n.eform-btn-actions-last {\n   border-radius: 0px 5px 5px 0px;\n}\n\n.field-option {\n   width: 255px;\n}\n\n.field-set {\n  border-color: red;\n}\n\n.margin-left-5 {\n   margin-left: 5px;\n}\n\n.margin-left-10 {\n   margin-left: 10px;\n}\n\n.margin-left-15 {\n   margin-left: 15px;\n}\n\n.margin-left-25 {\n   margin-left: 25px;\n}\n","@import \"../properties-theme\";\n\n.field-set-type-options {\n   padding: 4px;\n}\n\n.field-set-type-buttons {\n   border: 1px solid rgb(211, 211, 211);\n   font-size: 14px;\n   border-radius: 5px;\n   display: flex;\n   flex-direction: column;\n   margin-bottom: 10px;\n\n   legend {\n      font-weight: bold;\n      color: gray;\n   }\n\n   span {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n   }\n}\n\n.choice-options {\n   height: 130px;\n   overflow-x: hidden;\n   word-wrap: break-word !important;\n}\n\n.type-choice {\n   display: flex;\n   font-size: 14px;\n   flex-direction: column;\n\n   .mat-radio-button {\n      margin: 0px 0px 5px 5px;\n   }\n   .mat-radio-button:last-child {\n      margin-bottom: 0px !important;\n   }\n}\n\n.field-choice-layout {\n   display: flex;\n   justify-content: space-around;\n\n   button {\n      width: 100% !important;\n\n      mat-icon {\n         transform: scale(1.2);\n      }\n   }\n}\n\n.active {\n   background: lightblue;\n}\n\n.choice-header-options {\n   display: flex;\n   justify-content: space-around;\n   font-size: 12px;\n   font-weight: bolder;\n}\n\n.lookup {\n   justify-content: left !important;\n}\n\n.choices-body-options {\n   display: flex;\n   justify-content: flex-start;\n   margin: 0px !important;\n   padding: 1.5px;\n}\n\n.options-label {\n   width: 170px !important;\n}\n\n.options-value {\n   width: 70px !important;\n   margin-left: 4px;\n}\n\n.options-tableName {\n   width: 160px !important;\n}\n\n.options-columnName {\n   margin-left: 4px;\n   width: 100px !important;\n}\n\n.btn-options {\n   margin-left: 60px;\n   margin-bottom: 10px;\n}\n\n.options-margin-left-20 {\n   margin-left: 20px;\n}\n\n.icon-reorder-option {\n   font-size: 15px;\n   height: 0;\n   width: 0;\n   z-index: 100;\n   color: grey;\n   cursor: move;\n}\n\n.cdk-drag-preview {\n   opacity: 0;\n}\n\n.choice-custom-placeholder {\n   background: #ccc;\n   width: 260px;\n   height: 28px;\n   border: dotted 2px #999;\n   transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n::ng-deep .tooltip-red {\n   background: #b71c1c;\n}\n\n.actions-option {\n   align-self: center;\n   margin-left: -3px;\n   mat-icon {\n      color: grey;\n      font-size: 15px;\n      height: 0;\n      width: 10px !important;\n      margin-left: 5px;\n      cursor: pointer;\n   }\n}\n\n.errors-choice {\n   border-color: red;\n}\n\n.alert-icon {\n   margin-right: -13px;\n    font-size: 20px;\n    color: red;\n}\n\n::ng-deep .choice-control-properties .choices-body-options .mat-form-field-label {\n   font-size: 11px !important;\n   font-weight: bold;\n}\n\n::ng-deep .choice-control-properties .choices-body-options .mat-form-field-wrapper {\n   margin: 0px !important;\n}\n\n::ng-deep .choice-control-properties .choices-body-options .mat-form-field-appearance-outline .mat-form-field-infix {\n   font-size: 11px !important;\n   font-weight: bold;\n   margin: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
